import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import moment from 'moment'
import { config } from 'dotenv';

import HTML from './components/vue-components/src/components/core/HTML'
import DuplicateCandidates from '@/components/cvupload/DuplicateCandidates';
import Diff from '@/components/cvupload/Diff';

config();

import { datadogRum } from '@datadog/browser-rum';
datadogRum.init({
    applicationId: 'a4fdfcab-569b-4fd5-b973-609cf3306f6b',
    clientToken: 'pub37a06193ff3b9b17b3c9e0714f79a827',
    datacenter: 'us',
    sampleRate: 90
});
datadogRum.addRumGlobalContext('env', process.env.VUE_APP_DD_ENV);

const VueInputMask = require('vue-inputmask').default;
Vue.use(VueInputMask);

Vue.config.productionTip = false;

Vue.filter('formatDateTime', (value) => {
    if (value) {
        return moment.utc(value).format('DD/MM/YYYY HH:mm');
    }
});

Vue.filter('formatDate', (value) => {
    if (value) {
        return moment.utc(value).format('DD/MM/YYYY');
    }
});

Vue.filter('formatDateTimeLocal', (value) => {
    if (value) {
        return moment.utc(value).local().format('DD/MM/YYYY HH:mm');
    }
});

Vue.filter('formatDateLocal', (value) => {
    if (value) {
        return moment.utc(value).local().format('DD/MM/YYYY');
    }
});


Vue.filter('splitCamel', (value) => {
    if (value) {
        let x = value.replace(/([a-z])([A-Z])/g, '$1 $2');
        return x.charAt(0).toUpperCase() + x.slice(1);
    }
});

if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector;
if (!Element.prototype.closest) Element.prototype.closest = function (selector) {
    let el = this;
    while (el) {
        if (el.matches(selector)) {
            return el;
        }
        el = el.parentElement;
    }
};

Vue.component('HTML', HTML);
Vue.component('DuplicateCandidates', DuplicateCandidates);
Vue.component('Diff', Diff);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
